export default {
  images: [],
  isCrop: false,
  selectedStylesCrop: null,
  isCropSaved: true,
  isBlocked: false,
};
